// FRIA Meta Information
export const friaMetaInformation = {
  title: 'FRIA Meta-information',
  fields: [
    {
      label: 'FRIA Date',
      key: 'friaDate',
      placeholder: 'Select date',
      type: 'date',
    },
    {
      label: 'Date of Approval',
      key: 'dateOfApproval',
      placeholder: 'Select date',
      type: 'date',
    },
    {
      label: 'Prepared by (name, title)',
      key: 'preparedBy',
      placeholder: 'Enter details',
    },
    {
      label: 'Reviewed/approved by (name, title)',
      key: 'reviewedApprovedBy',
      placeholder: 'Enter details',
    },
  ],
};

// System Deployer Information
export const systemDeployerInformation = {
  title: 'System and Deployer Information',
  fields: [
    {
      label: 'Organisation Name',
      key: 'organisationName',
      placeholder: 'Enter Name',
    },
    {
      label: 'Address',
      key: 'address',
      placeholder: 'Enter Address',
    },
    {
      label: 'Contact Person (FRIA Owner)',
      key: 'contactPerson',
      placeholder: 'Enter contact person',
    },
    {
      label: 'Role/Title',
      key: 'roleTitle',
      placeholder: 'Enter role or title',
    },
    {
      label: 'Email',
      key: 'email',
      placeholder: 'Enter email',
      type: 'email',
    },
    {
      label: 'System Name',
      key: 'systemName',
      placeholder: 'Enter system name',
    },
    {
      label: 'Provider Name',
      key: 'providerName',
      placeholder: 'Enter provider name',
    },
    {
      label: 'Version / Model ID',
      key: 'versionModelID',
      placeholder: 'Enter version or model ID',
    },
    {
      label: 'High-risk category (Annex III reference)',
      key: 'highRiskCategory',
      placeholder: 'Enter Annex III reference',
    },
    {
      label: 'Internal system ID / reference',
      key: 'internalSystemID',
      placeholder: 'Enter system ID',
    },
    {
      label: 'Link/reference to provider\'s EU DoC & Annex IV',
      key: 'linkToProviders',
      placeholder: 'Enter link',
    },
  ],
};

// Use Context
export const useContext = {
  title: 'Use Context',
  fields: [
    {
      type: 'textArea',
      label: 'Business process where the system is used',
      key: 'businessProcess',
      placeholder: 'Describe the business or administrative process in which the AI system will be used (e.g. credit scoring, allocation of public benefits, staff scheduling, patient triage).',
    },
    {
      type: 'textArea',
      label: 'Purpose of deploying the system',
      key: 'purposeOfDeploying',
      placeholder: 'What outcome does the deployer aim to achieve with this AI system?',
    },
    {
      type: 'textArea',
      label: 'Does the system replace or support human judgement?',
      key: 'humanJudgement',
      placeholder: 'Explain how the system interacts with existing human decision-making processes.',
    },
  ],
};

// Role of System Options
export const roleOfSystemOptions = [
  {
    label: 'Supporting / recommending decisions',
    key: 'supporting',
  },
  {
    label: 'Advising with human final decision',
    key: 'advising',
  },
  {
    label: 'Automatic decision with human override option',
    key: 'automaticDecision',
  },
];

// Duration Frequency of Use
export const durationFrequencyOfUse = {
  title: 'Duration & Frequency of Use',
  fields: [
    {
      label: 'Expected start date of use',
      key: 'expectedStartDateOfUse',
      placeholder: 'Select date',
      type: 'date',
    },
    {
      label: 'Expected duration of use',
      key: 'expectedDurationOfUse',
      placeholder: 'Enter duration',
    },
    {
      label: 'Frequency of use',
      key: 'frequencyOfUse',
      placeholder: 'Enter frequency',
    },
    {
      label: 'Estimated number of individuals affected',
      key: 'estimatedNumberOfIndividualsAffected',
      placeholder: 'Enter number of individuals',
    },
    {
      type: 'textArea',
      label: 'Description of key “interaction moments” (e.g. at application, review, renewal)',
      key: 'descriptionInteractionMoments',
      placeholder: 'Describe the key interaction moments',
    },
  ],
};

// Affected Persons Groups
export const affectedPersonsGroups = {
  title: 'Affected Persons and Groups',
  fields: [
    {
      type: 'textArea',
      label: 'Primary affected individuals',
      key: 'primaryAffectedIndividuals',
      placeholder: 'List the main categories of individuals directly affected (e.g. customers, citizens, patients,   employees, students, migrants).',
    },
    {
      type: 'textArea',
      label: 'Indirectly affected persons/groups',
      key: 'indirectlyAffectedPersonsGroups',
      placeholder: 'List persons or groups indirectly affected (e.g. family members, dependents, co-workers).',
    },
    {
      type: 'textArea',
      label: 'Does the system replace or support human judgement?',
      key: 'humanJudgementForVulnerableGroups',
      placeholder: 'Explain how the system interacts with existing human decision-making processes.',
    },
  ],
};

// Vulnerable Groups Options
export const vulnerableGroupsOptions = [
  { label: 'Minors', key: 'minors' },
  { label: 'Elderly', key: 'elderly' },
  { label: 'Persons with disabilities', key: 'personsWithDisabilities' },
  { label: 'Migrants / asylum seekers', key: 'migrants' },
  { label: 'Socio-economically disadvantaged individuals', key: 'socioEconomicallyDisadvantagedIndividuals' },
];

// Fundamental Rights In Scope Options
export const fundamentalRightsInScopeOptions = [
  { label: 'Non-discrimination & equality', key: 'nonDiscriminationEquality' },
  { label: 'Privacy & data protection', key: 'privacyDataProtection' },
  { label: 'Right to a fair trial / due process', key: 'rightToFairTrial' },
  { label: 'Access to essential services / social benefits', key: 'accessEssentialServices' },
  { label: 'Worker\'s rights & fair working conditions', key: 'workersRights' },
  { label: 'Freedom of expression & information', key: 'freedomOfExpressionInformation' },
  { label: 'Protection of vulnerable groups', key: 'protectionOfVulnerableGroups' },
];

// Risk Scenario Fields (for DynamicFieldGroup)
export const riskScenarioFields = [
  {
    label: 'Risk ID',
    key: 'riskID',
    placeholder: 'Enter identifier',
  },
  {
    label: 'Fundamental Right',
    key: 'fundamentalRight',
    placeholder: 'Enter details',
  },
  {
    label: 'Risk Description',
    key: 'riskDescription',
    placeholder: 'Explain what could go wrong...',
  },
  {
    label: 'Affected Persons/Groups',
    key: 'affectedPersonsGroups',
    placeholder: 'Enter details',
  },
  {
    label: 'Existing controls',
    key: 'existingControls',
    placeholder: 'Enter details',
  },
];

// Likelihood Options
export const likelihoodOptions = [
  { label: 'Low', key: 'low' },
  { label: 'Medium', key: 'medium' },
  { label: 'High', key: 'high' },
];

// Severity Options
export const severityOptions = [
  { label: 'Low', key: 'low' },
  { label: 'Medium', key: 'medium' },
  { label: 'High', key: 'high' },
];

// Oversight Model Options
export const oversightModelOptions = [
  { label: 'Human-in-the-loop (human must approve outputs)', key: 'humanInTheLoop' },
  { label: 'Human-on-the-loop (monitoring with override)', key: 'humanOnTheLoop' },
  { label: 'Post-hoc review only', key: 'postHocReviewOnly' },
];

// Human Oversight
export const humanOversight = {
  title: 'Human Oversight',
  fields: [
    {
      type: 'textArea',
      label: 'Oversight roles & responsibilities',
      key: 'oversightRolesResponsibilities',
      placeholder: 'Describe which roles oversee the system, their responsibilities and their authority to override or stop system usage.',
    },
    {
      type: 'textArea',
      label: 'Oversight procedures',
      key: 'oversightProcedures',
      placeholder: 'Describe when human review is mandatory, escalation paths for unusual or high-risk cases, and how oversight decisions are documented.',
    },
    {
      type: 'textArea',
      label: 'Training',
      key: 'training',
      placeholder: 'Describe training provided to overseers and users on system functionality, limitations, bias, and fundamental rights risks.',
    },
  ],
};

// Mitigation Corrective Measures
export const mitigationCorrectiveMeasures = {
  title: 'Mitigation & Corrective Measures',
  fields: [
    {
      type: 'textArea',
      label: 'Data controls',
      key: 'dataControls',
      placeholder: 'Describe input data checks, quality rules, restrictions, and any fairness constraints implemented to mitigate risks.',
    },
    {
      type: 'textArea',
      label: 'Process & organizational controls',
      key: 'processOrganizationalControls',
      placeholder: 'Describe policies, SOPs, dual review mechanisms, second opinions, thresholds, and manual override rules used to manage risks.',
    },
    {
      type: 'textArea',
      label: 'Transparency & communication',
      key: 'transparencyCommunication',
      placeholder: 'Describe the information provided to affected individuals and workers (notices,   explanations, consultation) related to the AI system.',
    },
    {
      type: 'textArea',
      label: 'Incident handling & suspension rules',
      key: 'incidentHandlingSuspensionRules',
      placeholder: 'Describe how issues are detected, logged, escalated, and under what conditions system use   is paused or restricted.',
    },
    {
      type: 'textArea',
      label: 'Complaint & redress mechanisms',
      key: 'complaintRedressMechanisms',
      placeholder: 'Describe how individuals can appeal AI-influenced decisions, request review, and how   redress is provided (including decision reversal if applicable).',
    },
  ],
};

// Overall Risk Mitigation Status Options
export const overallRiskMitigationStatusOptions = [
  { label: 'Identified risks are mitigated to an acceptable level', key: 'identifiedRisksAreMitigated' },
  { label: 'Identified risks are not yet acceptable', key: 'identifiedRisksAreNotYetAcceptable' },
  { label: 'Risks are partially mitigated', key: 'risksArePartiallyMitigated' },
];

// Final Assessment Decision
export const finalAssessmentDecision = {
  title: 'Final Assessment & Decision',
  fields: [
    {
      type: 'textArea',
      label: 'Additional mitigation required before deployment',
      key: 'additionalMitigation',
      placeholder: 'Describe mitigation process',
    },
    {
      type: 'textArea',
      label: 'Conditions for deployment (if any)',
      key: 'conditionsForDeployment',
      placeholder: 'E.g. pilot only, restricted user groups, specific thresholds, additional oversight requirements, limited timeframe.',
    },
  ],
};

// Overall Decision Options
export const overallDecisionOptions = [
  { label: 'APPROVE', key: 'approve' },
  { label: 'APPROVE WITH CONDITIONS', key: 'approveWithConditions' },
  { label: 'POSTPONE / DO NOT DEPLOY', key: 'postponeDoNotDeploy' },
];

// Special keys for storing complex data as JSON strings
export const RISK_SCENARIOS_KEY = '__riskScenarios__';
export const VULNERABLE_GROUPS_KEY = '__vulnerableGroups__';
export const ROLE_OF_SYSTEM_KEY = '__roleOfSystem__';
export const FUNDAMENTAL_RIGHTS_IN_SCOPE_KEY = '__fundamentalRightsInScope__';
export const OVERSIGHT_MODEL_KEY = '__oversightModel__';
export const OVERALL_RISK_MITIGATION_STATUS_KEY = '__overallRiskMitigationStatus__';
export const OVERALL_DECISION_KEY = '__overallDecision__';
